import React from 'react';
import PropTypes from 'prop-types';

import { getCurrency } from '../../Utils/PriceUtils';

import { StyledWrapper, StyledSpan, BoldSpan } from './ProductDiscountSnippetStyles';

var getDiscountPrice = function getDiscountPrice(pdpDiscountSnippet, selectedVariant) {
  var discount = 100 - parseFloat(pdpDiscountSnippet.discount);
  return getCurrency('USD', selectedVariant.priceV2.amount * discount / 100);
};

var ProductDiscountSnippet = function ProductDiscountSnippet(_ref) {
  var pdpDiscountSnippet = _ref.pdpDiscountSnippet,
      selectedVariant = _ref.selectedVariant,
      pdpCollectionDiscount = _ref.pdpCollectionDiscount;

  var code = pdpCollectionDiscount && pdpCollectionDiscount.discountCode ? pdpCollectionDiscount.discountCode : pdpDiscountSnippet.promoCode;
  var discount = pdpCollectionDiscount && pdpCollectionDiscount.discountPercent ? pdpCollectionDiscount.discountPercent : pdpDiscountSnippet.discount;
  return React.createElement(
    StyledWrapper,
    null,
    React.createElement(
      'p',
      null,
      'Use code ',
      React.createElement(
        StyledSpan,
        null,
        code
      ),
      ' at checkout to get',
      ' ',
      React.createElement(
        BoldSpan,
        null,
        discount,
        '% Off!'
      )
    )
  );
};

ProductDiscountSnippet.propTypes = {
  selectedVariant: PropTypes.object,
  pdpDiscountSnippet: PropTypes.object
};

export default React.memo(ProductDiscountSnippet);